import { motion } from "framer-motion";
import DefaultSpacing from "../utilities/constants";
import { whyWorkWithUs } from "../utilities/whyWorkWithUsData";

const WhyWorkWithUS = () => {
  const defaultSpacing = new DefaultSpacing();
  const gap = defaultSpacing.getDefaultGap();

  return (
    <div className="flex flex-col gap-8">
      <h1 className="mb-6 text-center text-xl font-semibold text-white lg:text-36">
        Why Work With Us
      </h1>
      {/* <p className="text-center">
        Cillum adipisicing enim Lorem mollit minim laborum minim reprehenderit.
        Nisi in nisi veniam irure eiusmod laboris ad ipsum anim dolor
        reprehenderit. Adipisicing mollit laboris ipsum dolor minim laboris
        excepteur.
      </p> */}
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${gap}`}>
        {whyWorkWithUs.map((item) => {
          return (
            <motion.div
              key={item.title}
              whileHover={{
                scale: 1.05,
                transition: {
                  type: "spring",
                  stiffness: 150,
                  duration: 0.1,
                },
              }}
              className="col-span-1 flex flex-col items-center space-y-5 rounded-sm bg-white p-5"
            >
              <img src={item.icon} className="h-14 w-14" alt="" />
              <h2 className="text-center text-xl text-visBlue lg:text-2xl">
                {item.title}
              </h2>
              <p className="mt-2 text-center font-light">{item.discription}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default WhyWorkWithUS;
